import React from "react"

export const AppleIcon = () => {
  return (
    <svg
      width='26,75'
      height='25,89'
      viewBox='0 0 31 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.1955 29.9995C6.59046 29.9738 2.78125 20.8594 2.78125 16.2177C2.78125 8.63543 8.64779 6.97547 10.9087 6.97547C11.9276 6.97547 13.0156 7.36342 13.9752 7.70672C14.6462 7.94619 15.3403 8.1934 15.7262 8.1934C15.9573 8.1934 16.5017 7.98311 16.9824 7.79859C18.0075 7.40291 19.2832 6.91113 20.7686 6.91113C20.7713 6.91113 20.7748 6.91113 20.7774 6.91113C21.8866 6.91113 25.2497 7.14715 27.2716 10.0911L27.7452 10.7812L27.0636 11.2799C26.0898 11.9923 24.3131 13.2918 24.3131 15.8658C24.3131 18.9145 26.3253 20.087 27.292 20.6509C27.7187 20.8998 28.1604 21.1564 28.1604 21.7178C28.1604 22.0843 25.1435 29.9541 20.7624 29.9541C19.6903 29.9541 18.9326 29.6416 18.2642 29.3661C17.5879 29.0872 17.0045 28.8469 16.0404 28.8469C15.5518 28.8469 14.9338 29.0709 14.2797 29.3087C13.3857 29.6321 12.3738 29.9995 11.2256 29.9995H11.1955Z'
        fill='currentColor'
      />
      <path
        d='M21.2329 0C21.347 3.98883 18.4048 6.75609 15.4661 6.58254C14.9818 3.39932 18.4044 0 21.2329 0Z'
        fill='currentColor'
      />
    </svg>
  )
}
